import { HockeyIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Hourglass = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <HockeyIcon {...rest} size={Sizes[size]} color={fill} />;
};

Hourglass.displayName = 'Hourglass';
